module.exports = __webpack_public_path__ + "static/media/bg-pricing.92a2a9bc.jpeg";